import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropDownListComponent } from './dropdownlist.component';
import { DropDownListModule } from './dropdownlist.module';
/**
 * NgModule definition for the DropDownList component with providers.
 */
export class DropDownListAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, DropDownListModule],
    exports: [
        DropDownListModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DropDownListAllModule_tsickle_Closure_declarations() {
/** @type {?} */
DropDownListAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropDownListAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
